import React from 'react';
export function Guarantee() {
  return <section className="py-[60px] px-5 bg-brand-dark2" data-id="element-98">
      <div className="max-w-[860px] mx-auto" data-id="element-99">
        <h2 className="text-[clamp(22px,4vw,36px)] font-black text-white mb-3 text-center" data-id="element-100">
          Sin Riesgo — Garantía de 30 Días
        </h2>

        <div className="max-w-[560px] mx-auto bg-brand-dark3 border-2 border-brand-green/40 rounded-[20px] p-10 text-center" data-id="element-101">
          <div className="text-6xl mb-4" data-id="element-102">💯</div>
          <h3 className="text-[clamp(20px,3vw,28px)] font-black text-brand-green mb-4" data-id="element-103">
            Garantía de Satisfacción Total
          </h3>
          <p className="text-[15px] text-[#cdd9e5] leading-[1.7] mb-3" data-id="element-104">
            Si en 30 días aplicas el sistema y no ves ningún resultado —{' '}
            <strong className="text-white" data-id="element-105">te devolvemos cada centavo.</strong>
          </p>
          <p className="text-[15px] text-[#cdd9e5] leading-[1.7] mb-3" data-id="element-106">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <p className="italic text-brand-gray text-[15px]" data-id="element-107">
            El riesgo es completamente nuestro. Tú pones la acción. Nosotros
            ponemos la garantía.
          </p>
        </div>
      </div>
    </section>;
}